import styled from 'styled-components'
import theme from 'styles/theme'

export const SocialSharingWrapper = styled.ul`
  padding: ${theme.space[5]} 0;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  justify-content: center;
  max-width: 500px;
`

export const SocialSharingItem = styled.li`
  margin: ${theme.space[1]} ${theme.space[1]};
  width: 40px;
  height: 40px;
  position: relative;

  & > a {
    position: absolute;
    left: 0;
  }
`

export default {
  SocialSharingWrapper,
  SocialSharingItem,
}
